import styles from "./styles/parameter-slider.module.scss";
import tooltipStyles from "@/components/common/styles/tooltip.module.scss";
import React, { useEffect, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import { ConversionEffectParameter } from "@/data/convert-effects.data";
import StyledSlider from "@/components/common/styled-slider";

type ParameterSliderProps = {
  parameter: ConversionEffectParameter;
  handleChecked: () => void;
  handleValueChanged: (value: number) => void;
  maxTitleBlockWidth?: number;
  setTitleBlockWidth: (value: number) => void;
};

const ParameterSlider = ({
  parameter,
  handleChecked,
  handleValueChanged,
  maxTitleBlockWidth,
  setTitleBlockWidth,
}: ParameterSliderProps) => {
  const titleBlock = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (titleBlock.current) {
      setTitleBlockWidth(titleBlock.current.offsetWidth);
    }
  }, [titleBlock]);

  useEffect(() => {
    if (titleBlock.current) {
      if (maxTitleBlockWidth) {
        titleBlock.current.style.width = `${maxTitleBlockWidth}px`;
      } else {
        titleBlock.current.style.width = `fit-content`;
      }
    }
  }, [maxTitleBlockWidth]);

  return (
    <div className={styles.parameter_slider}>
      {/*<CheckBox onChange={handleChecked} isChecked={parameter.isChecked} />*/}
      <div
        ref={titleBlock}
        className={styles.title}
        data-tooltip-id="parameterTooltip"
        data-tooltip-content={parameter.tooltip}
      >
        {parameter.displayName}
        <Tooltip
          className={tooltipStyles.tooltip}
          id="parameterTooltip"
          place="top"
        />
      </div>
      <div className={styles.slider_wrapper}>
        <div className={styles.side_value_wrapper}>{parameter.minValue}</div>
        <div className={styles.value_slider_wrapper}>
          <div className={styles.top_value_wrapper}>
            {/*{parameter.isChecked ? parameter.value : 0}*/}
            {parameter.value}
          </div>
          <StyledSlider
            min={parameter.minValue}
            max={parameter.maxValue}
            step={parameter.step}
            value={parameter.value}
            // disabled={!parameter.isChecked}
            onChange={(e) => handleValueChanged(parseFloat(e.target.value))}
          />
        </div>
        <div className={styles.side_value_wrapper}>{parameter.maxValue}</div>
      </div>
    </div>
  );
};

export default ParameterSlider;
